/**
 * Die Suche nach einer Person – über Name und E-Mail zugleich.
 *
 * Eine Funktion für jede Stelle, an der eine Person gewählt oder gesucht
 * wird, damit „Fuesslein" überall dieselben Treffer bringt. Die Liste der
 * Mitarbeiter blättert nicht (es sind die Personen mit aktiver Rolle, ein
 * paar Dutzend), also wird hier gesucht und nicht in der API.
 */

/** Klein, ohne Akzente, Umlaute ausgeschrieben – „Füßlein" und „fuesslein" sind dasselbe. */
export function suchform(text: string): string {
  return text
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/**
 * Passt die Person zur Suche? Jedes Wort muss im Namen oder in der E-Mail
 * stehen – „felix kallmann" findet Felix über seine Adresse. Eine leere
 * Suche passt auf jeden.
 */
export function personPasst(person: { name: string; email: string }, suche: string): boolean {
  const woerter = suchform(suche).split(/\s+/).filter(Boolean);

  if (woerter.length === 0) return true;

  const heuhaufen = `${suchform(person.name)} ${suchform(person.email)}`;

  return woerter.every((w) => heuhaufen.includes(w));
}
